"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _bridge = _interopRequireDefault(require("../bridge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function applyHeaders() {
  return {
    headers: {
      Authorization: "Bearer " + localStorage.getItem(_bridge.default.getConfig("localPrefix") + "access_token")
    }
  };
}

var _default = {
  auth: {
    exchange_code: function exchange_code(code) {
      return _axios.default.post(_bridge.default.getConfig("applicationServer") + "/../oauth/code_exchange", {
        code: code
      }).then(function (res) {
        return res.data;
      });
    },
    logout: function logout() {
      return _axios.default.delete(_bridge.default.getConfig("applicationServer") + "/../oauth/token", applyHeaders()).then(function (res) {
        return res.data;
      });
    },
    user_details: function user_details(access_token) {
      return _axios.default.get(_bridge.default.getConfig("applicationServer") + "/../oauth/user_details", {
        headers: {
          Authorization: "Bearer " + access_token
        }
      }).then(function (res) {
        return res.data;
      });
    }
  }
};
exports.default = _default;